import { render, staticRenderFns } from "./OrganizationsPage.vue?vue&type=template&id=4e790831&scoped=true"
import script from "./OrganizationsPage.vue?vue&type=script&lang=js"
export * from "./OrganizationsPage.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsPage.vue?vue&type=style&index=0&id=4e790831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e790831",
  null
  
)

export default component.exports